import React from 'react';
import { useCanvasStageOperations } from 'state/canvas/stage';
import useOnSurfaceChange from 'routes/surface/hooks/use-on-surface-change';
import useMiniMapOperations from 'components/canvas/components/mini-map/hooks/mini-map-operations';
import { Position } from 'types';

export default function useMiniMapViewPortPosition(
  surface: string,
): [Position | undefined, (position: Position) => void] {
  const { getCanvasStageById } = useCanvasStageOperations(surface);

  const { translateCanvasPositionToMiniMapPosition } = useMiniMapOperations(
    surface,
  );

  const [position, setPosition] = React.useState<Position | undefined>();

  useOnSurfaceChange((surface) => {
    // We will give enough time for stage to load before setting the position of viewport.
    // This is used so that initial viewport position does not interfere in mini map scale to fit.
    // When nodes are loaded and user is first time on the stage. Stage position will be { x: 0, y: 0 } but nodes could be located somewhere else...this could lead to viewport showing empty canvas. That is not a good UX we want to show user nodes.
    if (surface) {
      const stage = getCanvasStageById(surface);

      const position = translateCanvasPositionToMiniMapPosition(stage);

      setPosition(position);
    }
  });

  return [position, setPosition];
}
